// extracted by css-extract-rspack-plugin
export default {"bold":"Description__bold--MxGfO"};